function loadProductForm() {
  return import('{{ "product-form.js"  | asset_url }}');
}

function loadProductInfo() {
  return import('{{ "product-info.js"  | asset_url }}');
}

function loadProductModal() {
  return import('{{ "product-modal.js" | asset_url }}');
}
if (document.querySelector('product-form')) loadProductForm();
if (document.querySelector('[data-product-info], product-info')) loadProductInfo();
if (document.querySelector('product-modal, .product-media-modal')) loadProductModal();

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('product-form')) loadProductForm();
  if (e.target.querySelector('[data-product-info], product-info')) loadProductInfo();
  if (e.target.querySelector('product-modal, .product-media-modal')) loadProductModal();
});